import { SpatialNavigator, type SpatialNavigatorOptions } from "./spatial-navigator";
declare module '#app' {
    interface NuxtApp {
        $navigator: SpatialNavigator;
    }
}
declare module "vue" {
    interface Vue {
        $navigator: SpatialNavigator;
    }
}

export default defineNuxtPlugin(nuxtApp => {
    const defaultOptions: SpatialNavigatorOptions = {
        keyBack: [27, 461, 10009, "Back", 32],
        keyDown: [40, "ArrowDown"],
        keyLeft: [37, "ArrowLeft"],
        keyRight: [39, "ArrowRight"],
        keyUp: [38, "ArrowUp"],
        keyEnter: [13, "Enter"],
        keyNumber: [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
    };
    const navigator = SpatialNavigator.create(defaultOptions)
    nuxtApp.provide('navigator', navigator);
});
